module.exports = "/_next/static/images/8a2469bc794a807688226dec41b6f347-mulher-com-cachos-maravilhosos-segurando-cartao-xs@2x.jpg";